import { Icon } from "@/components/icons/Icon";
import { twMerge } from "@/utils/twMerge";

export function NodeProperty({
  name,
  value,
  disabled,
  hideToggle,
  readOnly,
  className,
}: {
  name: React.ReactNode;
  value: React.ReactNode;
  disabled?: boolean;
  hideToggle?: boolean;
  readOnly?: boolean;
  className?: string;
}) {
  let stateClassName = "hover:bg-suggestion-option-active-bg cursor-pointer";
  if (readOnly) stateClassName = "cursor-default";
  if (disabled) stateClassName = "opacity-40";

  return (
    <div
      className={twMerge(
        "font-sans flex flex-nowrap items-center rounded-6 px-2 min-h-9 text-sm",
        stateClassName,
        className,
      )}
    >
      <span className="text-gray-500 dark:text-gray-400 mr-1">{name}:</span>
      {value}
      {!hideToggle && !readOnly && <Icon name="ChevronDown" className="ml-auto" />}
    </div>
  );
}

export function ReadOnlyTextProperty({
  name,
  value,
  mono,
}: {
  name: React.ReactNode;
  value: string;
  mono?: boolean;
}) {
  return (
    <NodeProperty
      name={name}
      value={mono ? <span className="font-mono">{value}</span> : <span>{value}</span>}
      readOnly
    />
  );
}
